<template>
  <div>
    <slide :items="items"></slide>
    <div class="btn-start">
      <router-link :to="{name: 'LoginPage'}" v-if="!existedToken"><base-button>{{ $t('home.getStarted') }}</base-button></router-link>
      <router-link :to="{name: 'MedialPage'}" v-if="existedToken"><base-button>{{ $t('home.getStarted') }}</base-button></router-link>
    </div>
  </div>
</template>

<script>
import Slide from '../components/Slide';
import BaseButton from "../components/Button.vue";

export default {
  components: {
    BaseButton,
    Slide,
  },
  name: 'HomePage',
  data() {
    return {
      msg: 'Welcome to CCALL',
      existedToken: ''
    };
  },
  computed: {
    items() {
      return [
        {
          image: './static/ccall.png',
          title: 'slider.title1',
          desc: 'slider.desc1',
        },
        {
          image: './static/performance.png',
          title: 'slider.title2',
          desc: 'slider.desc2',
        },
        {
          image: './static/statistic.png',
          title: 'slider.title3',
          desc: 'slider.desc3',
        },
        {
          image: './static/lego.png',
          title: 'slider.title4',
          desc: 'slider.desc4',
        },
        {
          image: './static/clock.png',
          title: 'slider.title5',
          desc: 'slider.desc5',
        },
        {
          image: './static/user.png',
          title: 'slider.title6',
          desc: 'slider.desc6',
        },
        {
          image: './static/space.png',
          title: 'slider.title7',
          desc: 'slider.desc7',
        },
      ]
    }
  },
  mounted() {
    const token = localStorage.getItem('token');
    this.existedToken = token;
    /*
    if (token) {
      this.$router.push({name: 'LoginPage'});
    }
    */
  }
};
</script>

<style scoped="">
  .btn {
    width: 50%;
  }
</style>



// WEBPACK FOOTER //
// src/pages/HomePage.vue